import type { PatientTabConfig } from '../types';

export const getVisibleIds = (tabs: PatientTabConfig[]) => tabs.filter((tab) => tab.visible).map((tab) => tab.id);
